/* eslint-disable prettier/prettier */
export { OldThemeContext } from './old_theme/context/themeContext'
export { useTheme } from './old_theme/hooks/useTheme'
export { withTheme } from './old_theme/hoc/withTheme'
export { mergeRefs } from './react/mergeRefs'
export { NoSSR } from './next/NoSSR'
export { Meta } from './next/Meta'
export { BreadCrumbsActionsContext, BreadCrumbsContext } from './breadcrumbs/context/breadcrumbs'
export { useBreadCrumbs, useBreadCrumbsData } from './breadcrumbs/hooks/useBreadCrumbs'
export { generateUuid } from './utils/generateUuid'
export { generatePath } from './utils/generatePath'
export { parseAmount } from './utils/parseAmount'
export { toNumber } from './utils/toNumber'
export { useIntersectionObserver } from './hooks/useIntersectionObserver'

// redesign
export { useTypewriter } from './hooks/useTypewriter'
export { convertPxToRem } from './utils/convertPxToRem'
export { useHeaderHeight } from './hooks/useHeaderHeight'
export { useElementTrigger } from './hooks/useElementTrigger'
export { useModal } from './hooks/useModal'
export { removeFirstSubstring } from './utils/removeFirstSubstring'
export { composeQueryParams } from './utils/composeQueryParams'
export { useCheckLocalStorageItemExistance } from './utils/useCheckLocalStorageItemExistance'
export { useInputFocus } from './hooks/useInputFocus'
export { useIntervalCallback } from './hooks/useIntervalCallback'
export { delay } from './utils/delay'
export { memoizeAsync } from './utils/memoizeAsync'
export { useElementRectById } from './hooks/useElementRectById'
export { useCurrentTspOnly } from './hooks/useCurrentTspOnly'
export { detectPlatform } from './utils/detectPlatform'
export { declension } from './utils/declension'
export { formatCardNumber } from './utils/formatCardNumber'
export { formatExpiryDate } from './utils/formatExpiryDate'
export { scrollToFirstErrorField } from './utils/scrollToFirstErrorField'
export { isChromeOrEdge } from './utils/isChromeOrEdge'
